import { useMutation } from "react-query";
import { post } from "../../data";

export const useFinalQaBulkReject = () => {
    return useMutation(({ rejectTasks, selectedUpcs }) => {
        const payload = {
            rejectTasks: rejectTasks.map(({ task, reason, other, upcs }) => {
                return {
                    taskType: task,
                    defaultReason: reason === "0" ? "" : reason || "",
                    defaultReasonAdditionalText: other || "",
                    products:
                        upcs.length > 0
                            ? upcs.map((product) => {
                                  const selectedProduct = selectedUpcs.find(
                                      ({ context }) => context.upc === product.upc && context.key === product.contextKey
                                  );

                                  return {
                                      finalQaTaskKey: selectedProduct?.key,
                                      taskContextKey: selectedProduct?.context?.key,
                                      shipmentProductKey: selectedProduct?.context?.shipmentProductKey,
                                      rejectReasonOverride: product.reason === "0" ? "" : product.reason || "",
                                      rejectReasonAdditionalTextOverride: product.other || "",
                                  };
                              })
                            : selectedUpcs.map((product) => {
                                  return {
                                      finalQaTaskKey: product.key,
                                      taskContextKey: product.context?.key,
                                      shipmentProductKey: product.context?.shipmentProductKey,
                                  };
                              }),
                };
            }),
        };

        return post("/receiving/final/bulk-reject", payload, { displayError: true, passthrough: true });
    });
};
